export type {
  MessageBarTitleProps,
  MessageBarTitleSlots,
  MessageBarTitleState,
} from './components/MessageBarTitle/index';
export {
  MessageBarTitle,
  messageBarTitleClassNames,
  renderMessageBarTitle_unstable,
  useMessageBarTitleStyles_unstable,
  useMessageBarTitle_unstable,
} from './components/MessageBarTitle/index';
